import { varBounceOut, varBounceOutDown, varBounceOutLeft, varBounceOutRight, varBounceOutUp } from './BounceOut';

// ----------------------------------------------------------------------

const TRANSITION_ENTER = {
  duration: 0.72,
  ease: [0.43, 0.13, 0.23, 0.96],
};

const TRANSITION_EXIT = {
  duration: 0.48,
  ease: [0.43, 0.13, 0.23, 0.96],
};

export const varBounceIn = {
  animate: {
    opacity: [0, 1, 1, 1, 1, 1],
    scale: [0.3, 1.1, 0.9, 1.03, 0.97, 1],
    transition: TRANSITION_ENTER,
  },
  exit: varBounceOut.animate,
};

export const varBounceInUp = {
  animate: {
    opacity: [0, 1, 1, 1, 1],
    scaleY: [4, 0.9, 0.95, 0.985, 1],
    transition: { ...TRANSITION_ENTER },
    y: [720, -24, 12, -4, 0],
  },
  exit: { ...varBounceOutDown.animate, transition: TRANSITION_EXIT },
};

export const varBounceInDown = {
  animate: {
    opacity: [0, 1, 1, 1, 1],
    scaleY: [4, 0.9, 0.95, 0.985, 1],
    transition: TRANSITION_ENTER,
    y: [-720, 24, -12, 4, 0],
  },
  exit: { ...varBounceOutUp.animate, transition: TRANSITION_EXIT },
};

export const varBounceInLeft = {
  animate: {
    opacity: [0, 1, 1, 1, 1],
    scaleX: [3, 1, 0.98, 0.995, 1],
    transition: TRANSITION_ENTER,
    x: [-720, 24, -12, 4, 0],
  },
  exit: { ...varBounceOutLeft.animate, transition: TRANSITION_EXIT },
};

export const varBounceInRight = {
  animate: {
    opacity: [0, 1, 1, 1, 1],
    scaleX: [3, 1, 0.98, 0.995, 1],
    transition: TRANSITION_ENTER,
    x: [720, -24, 12, -4, 0],
  },
  exit: { ...varBounceOutRight.animate, transition: TRANSITION_EXIT },
};
